import React, {Component} from 'react'
import {connect} from 'react-redux'
import cookie from 'react-cookies'
import {Button, Col, Input, Row, Select, Spin, Tooltip} from 'antd'
import 'asset/style/dashboard.css'
import 'asset/style/add_case.css'
import 'asset/style/theme/theme.scoped.scss';
import {ArrowLeftOutlined, ArrowRightOutlined, InfoCircleFilled} from '@ant-design/icons'
import {aclPermissions, hasPermissions} from 'const/ACLPermissions'
import ConfirmUserPermissions from 'component/settings/managepermission/confirm.userpermissions'
import {isNull} from 'utils/utils'
import {error_manager} from 'helper/error_manager'
import {
    getAccessPolicyPermissionsAndMembers,
    getAllAccessPermissionCategories,
    getAllAccessPermissions,
    getAllAccessPolicies,
    getUserAccessPermissionsAndPolicy
} from "../utils/api";
import {antdSpinLoaderIcon} from "../utils/const";
import ForceLogout from "../component/settings/force_logout";
import {Divider} from "@mui/material";

class ManagePermission extends Component {
    constructor(props) {
        super(props)

        this.state = {
            policyPermissions: [],
            userPermissions: [],
            inputAvailable: '',
            inputSelected: '',
            policy: '',
            allPermissions: [],
            allCategories: [],
            allPolicies: [],
            retainPermissions: false,
            policyDetailsFetched: false,
            showLogoutModal: false,
        }

        this.addPermission = this.addPermission.bind(this)
        this.removePermission = this.removePermission.bind(this)
        this.updatePolicy = this.updatePolicy.bind(this)

        this.AvailablePermSelectId = "avaiable-perm-select-id"
        this.ChosenPermSelectId = "chose-perm-select-id"
    }

    componentDidMount() {
        const storedModalState = localStorage.getItem('showLogoutModal');
        if (storedModalState) {
            this.setState({showLogoutModal: JSON.parse(storedModalState)});
        }

        getAllAccessPermissionCategories()
            .then(data => this.setState({allCategories: data['access_permission_categories']}))

        this.fetchAllPolicies()

        this.fetchAllAccessPermissions()
        this.fetchCurrPermissions({
            username: this.props.username,
            organisation: this.props.organisation,
        })
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps?.username !== this.props.username) {
            this.fetchAllAccessPermissions()
            this.fetchCurrPermissions({
                username: this.props.username,
                organisation: this.props.organisation,
            })
        }

        if (prevState?.policy !== this.state.policy) {
            if (this.state.policy) {
                this.fetchPolicyDetails({
                    policy: this.state.policy,
                    organisation: this.props.organisation,
                })
            } else if (!this.state.retainPermissions) {
                this.setState({policyPermissions: []})
            }
        }

        if (prevState?.policyPermissions === this.state.policyPermissions &&
            prevState?.userPermissions === this.state.userPermissions) {
            return
        }

        if (!this.state.retainPermissions) {
            const filterPermissions = this.state.userPermissions.filter(p =>
                !this.state.policyPermissions.includes(p)
            )
            if (filterPermissions.length === this.state.userPermissions.length) return
            this.setState({userPermissions: filterPermissions})
        }
    }

    fetchAllAccessPermissions = () => {
        getAllAccessPermissions(this.props.username)
            .then(data => this.setState({ allPermissions: data["access_permissions"] }))
    }

    fetchCurrPermissions = async ({ username, organisation }) => {
        const policies = this.state.allPolicies
        policies?.push({ value: '', name: '' })

        if (!username) return

        await getUserAccessPermissionsAndPolicy(username)
            .then(data => {
                const userPermissions = data?.permissions
                const policy = data?.policy || ''
                this.setState({userPermissions, policy})
            }).catch(err => {
                error_manager("Unable to fetch user access permissions & policy", err)
            })

        this.fetchPolicyDetails({
            policy: this.state.policy,
            organisation,
        })
    }

    fetchPolicyDetails = ({ policy, organisation }) => {
        if (!policy) return
        this.setState({policyDetailsFetched: true})
        getAccessPolicyPermissionsAndMembers(organisation, policy)
            .then(data => {
                const policyPermissions = data?.permissions
                this.setState({policyPermissions, policy, policyDetailsFetched: false})
            })
    }

    fetchAllPolicies = () => {
        getAllAccessPolicies(this.props.organisation).then(data => this.setState({allPolicies: data['all_access_policies']}))
    }

    addPermission = () => {
        const options = document.getElementById(this.AvailablePermSelectId)?.options
        const selected = []

        for (let option of options) {
            if (!option?.selected) continue
            selected.push(option.value)
        }

        this.setState(state => ({
            ...state,
            userPermissions: [...state.userPermissions, ...selected]
        }))
    }

    removePermission = () => {
        const options = document.getElementById(this.ChosenPermSelectId)?.options
        const selected = []

        for (let option of options) {
            if (!option?.selected) continue
            selected.push(option.value)
        }

        this.setState(state => ({
            ...state,
            userPermissions: state.userPermissions.filter(p => !selected.includes(p))
        }))
    }

    updatePolicy = (policy) => {
        if (!policy) return
        this.setState({policy, retainPermissions: false})
    }

    renderSelectedPermissions (policyPermissions, userPermissions, hint) {
        const optGroups = {}
        const allPerms = this.state.allPermissions
        const allCategories = this.state.allCategories

        let idx = 0
        for (let {name, label, category} of allPerms) {
            let elem = null
            if (!label?.toLowerCase()?.includes(hint?.toLowerCase())) continue

            if (userPermissions.includes(name)) {
                elem = (
                    <option key={`selected_perm_${name}_${idx}`} value={name}>
                        {label}
                    </option>
                )
            }

            if (policyPermissions.includes(name)) {
                elem = (
                    <option key={`selected_perm_${name}_${idx}`} disabled>
                        {this.state.retainPermissions ? `${label}` : `${label} (inherited from ${this.state.policy})`}
                    </option>
                )
            }

            if (!elem) continue

            if (!optGroups.hasOwnProperty(category)) optGroups[category] = []
            optGroups[category].push(elem)

            idx++
        }

        const sortedEntries = Object.entries(optGroups).sort((([name, _]) => name))

        return (
            <div>
                <Row span={5}>
                    <select multiple className="multi_select_box" id={this.ChosenPermSelectId}>
                        {sortedEntries.map(([name, permissions]) =>
                            <optgroup
                                label={allCategories.find(c => c.name === name)?.label}
                                key={`select_optgroup_${name}_${permissions.length}`}>
                                {permissions}
                            </optgroup>
                        )}
                    </select>
                </Row>
            </div>
        )
    }

    renderAvailablePermissions (policyPermissions, userPermissions, hint) {
        const optGroups = {}
        const allPerms = this.state.allPermissions
        const allCategories = this.state.allCategories

        for (let {name, label, category} of allPerms) {
            if (!optGroups.hasOwnProperty(category)) optGroups[category] = []
            optGroups[category].push({ name, label })
        }

        const sortedEntries = Object.entries(optGroups).sort((([name, _]) => name))

        return (
            <select multiple className="multi_select_box" id={this.AvailablePermSelectId}>
                 {
                    sortedEntries
                    ?.map(([name, permissions]) => [name, permissions?.filter(p => p.label?.toLowerCase()?.includes(hint?.toLowerCase()))])
                    ?.map(([name, permissions]) =>
                    permissions.length > 0 ?
                        (<optgroup
                                label={allCategories.find(c => c.name === name)?.label}
                                key={`optgroup_${name}_${permissions.length}`}>
                            {permissions?.map((p, idx) => {
                                const isSelected = policyPermissions?.includes(p.name) || userPermissions?.includes(p.name)
                                return (
                                    <option
                                        disabled={isSelected}
                                        key={`unselected_perm_${p.name}_${idx}_${isSelected}`}
                                        value={p.name}
                                    >
                                        {this.state.retainPermissions ? `${p.label}` :
                                            `${p.label} ${policyPermissions.includes(p.name) ? `(inherited from ${this.state.policy})` : ''}`}
                                    </option>
                                )
                            })}
                        </optgroup>) : (<div></div>)
                    )
                }
            </select>)
    }

    closeModal = (message) => {
        this.props.setShowSaveModal(false)

        switch (message) {
            case "SAVED":
                this.props.saveUser();
                if (this.props.username === cookie.load('username')) {
                    this.setState({showLogoutModal: true});
                    localStorage.setItem('showLogoutModal', JSON.stringify(true));
                }
                break

            case "NO_CHANGE":
                this.props.saveUser()
                break

            case "ERROR":
                error_manager("unable to save")
                break

            case "CANCEL":
                break

            default:
                error_manager("unknown confirm message")
        }
    }

    handleCloseLogoutModal = () => {
        localStorage.setItem("showLogoutModal", "false");
        this.setState({showLogoutModal: false});
    };

    render() {

        if (isNull(this.props.organisation)) return null;

        return (<>
                {cookie.load("username") === this.props.username ||
                hasPermissions([aclPermissions.view_other_user_permissions, aclPermissions.update_user]) ? (
                    <Row span={24} style={{marginLeft: "40px"}}>
                        <Spin spinning={this.state.policyDetailsFetched} indicator={antdSpinLoaderIcon}>
                            <Row>
                                <Col span={24}>
                                    <div style={{fontSize: 20, fontWeight: 400}}>Access Permissions</div>
                                    <Divider color={"#000"} style={{opacity: "0.2", marginTop: 10, marginRight: 10}}/>
                                </Col>
                                <Col span={24}>
                                    <div>
                                        <Row style={{borderBottom: "None", marginTop: "10px", marginLeft: "15px"}}>
                                            <Col xl={2} xs={12} className="add-case-row-header">
                                                <Row><b>Policy</b>&nbsp;
                                                        <Tooltip title={'access permissions inherited by user'}
                                                                 trigger="hover">
                                                            <InfoCircleFilled/>
                                                        </Tooltip>
                                                </Row>
                                            </Col>
                                            <Col xl={4} xs={12}>
                                                <Select
                                                    style={{width: "100%"}}
                                                    placeholder={"Select a Policy"}
                                                    autoComplete="off"
                                                    onChange={(value) => this.updatePolicy(value)}
                                                    value={this.state.policy || "Select a Policy"}
                                                    disabled={!hasPermissions([aclPermissions.update_user])}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.props.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {this.state.allPolicies
                                                        .sort((a, b) => a.name.localeCompare(b.name))
                                                        .map(({name}) => (
                                                            <Select.Option key={name}
                                                                           value={name}>{name}</Select.Option>
                                                        ))}
                                                </Select>
                                            </Col>
                                            <Col xl={2} style={{marginLeft: "10px"}} xs={12}>
                                                <Button
                                                    onClick={() => this.setState({policy: ''})}
                                                    style={{
                                                        width: "100%"
                                                    }}
                                                    disabled={!hasPermissions([aclPermissions.update_user])
                                                        || this.state.policy === ''}
                                                    type="danger"
                                                    ghost
                                                >
                                                    Remove Policy
                                                </Button>
                                            </Col>
                                            <Col xl={3} style={{marginLeft: "10px"}} xs={12}>
                                                <Button
                                                    onClick={() => this.setState({
                                                        retainPermissions: true, policy: '',
                                                        userPermissions: [...this.state.userPermissions, ...this.state.policyPermissions],
                                                        policyPermissions: []
                                                    })}
                                                    disabled={!hasPermissions([aclPermissions.update_user])
                                                        || this.state.policy === ''}
                                                    type="danger"
                                                    ghost
                                                >
                                                    Remove Policy, Retain Permissions
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={22}>
                                                <Divider color={"#000"} style={{opacity: "0", marginTop: 5}}/>
                                            </Col>
                                        </Row>
                                        <Row className="add-case-row" type="flex" style={{borderBottom: "None"}}>
                                            <Col span={9}>
                                                <Row span={12}>
                                                    <Row span={5} className="add-case-row-header">
                                                        <b>Available Permissions</b>
                                                    </Row>
                                                    <Row span={5} className="add-case-row-header">
                                                        <Input
                                                            autoComplete="off"
                                                            className="input-field-add-case"
                                                            style={{color: 'black', width: '100%'}}
                                                            value={this.state.inputAvailable}
                                                            placeholder={'Search'}
                                                            onChange={(e) => this.setState({inputAvailable: e?.target?.value})}/>
                                                    </Row>
                                                    <Row span={5} className="add-case-row-header" push={3}>
                                                        {this.renderAvailablePermissions(
                                                            this.state.policyPermissions,
                                                            this.state.userPermissions,
                                                            this.state.inputAvailable?.trim()
                                                        )}
                                                    </Row>
                                                </Row>
                                            </Col>
                                            <Col
                                                offset={1}
                                                style={{
                                                    display: 'flex',
                                                    'align-items': 'center',
                                                    'justify-content': 'center',
                                                    'flex-direction': 'column',
                                                    gap: '16px'
                                                }}>
                                                <Row>
                                                    <Button
                                                        type="default"
                                                        onClick={this.addPermission}
                                                        disabled={!hasPermissions([aclPermissions.update_user])}
                                                    >
                                                        <ArrowRightOutlined/>
                                                    </Button>
                                                </Row>
                                                <Row>
                                                    <Button
                                                        type="default"
                                                        onClick={this.removePermission}
                                                        disabled={!hasPermissions([aclPermissions.update_user])}
                                                    >
                                                        <ArrowLeftOutlined/>
                                                    </Button>
                                                </Row>
                                            </Col>
                                            <Col span={9} offset={1}>
                                                <Row span={12}>
                                                    <Row span={5} className="add-case-row-header">
                                                        <b>Chosen Permissions</b>
                                                    </Row>
                                                    <Row span={5} className="add-case-row-header">
                                                        <Input
                                                            autoComplete="off"
                                                            className="input-field-add-case"
                                                            style={{color: 'black', width: '100%'}}
                                                            value={this.state.inputSelected}
                                                            placeholder={'Search'}
                                                            onChange={(e) => this.setState({inputSelected: e?.target?.value})}/>
                                                    </Row>
                                                    <Row span={5} className="add-case-row-header" push={3}>
                                                        {this.renderSelectedPermissions(
                                                            this.state.policyPermissions,
                                                            this.state.userPermissions,
                                                            this.state.inputSelected?.trim()
                                                        )}
                                                    </Row>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                {/* <div className="submit-row-add-case">
                            <Row>
                                <Col span={2}>
                                    <Button type="primary" onClick={() => this.props.setShowSaveModal(true)}>
                                        Save
                                    </Button>
                                </Col>
                            </Row>
                        </div> */}
                            </Row>
                        </Spin>
                    </Row>
                ) : <></>}

                {this.props.showSaveModal && <ConfirmUserPermissions
                    key={`confirm_user_perm_${Math.random()}`}
                    closeModal={this.closeModal}
                    visible={this.props.showSaveModal}
                    username={this.props.username}
                    allPermissions={this.state.allPermissions}
                    allCategories={this.state.allCategories}
                    updatedPolicy={this.state.policy}
                    retainPermissions={this.state.retainPermissions}
                    updatedPolicyPermissions={this.state.policyPermissions}
                    updatedUserPermissions={this.state.userPermissions}
                    allPolicies={this.state.allPolicies}
                    organisation={this.props.organisation}
                />}
                <ForceLogout visible={this.state.showLogoutModal} onClose={this.handleCloseLogoutModal}
                             message={'policies and permissions'}/>
            </>
        )
    }
}

const mapStateToProps = state => ({
    allPermissions: state.aclReducer.allPermissions,
    allPolicies: state.aclReducer.allPolicies,
    allCategories: state.aclReducer.allPermissionCategories,
})

export default connect(mapStateToProps)(ManagePermission)
